// extracted by mini-css-extract-plugin
export default {"container":"SignIn_container__rxiFS","description":"SignIn_description__7XXu-"};